import { render, staticRenderFns } from "./IviewTable11.vue?vue&type=template&id=71b97350&scoped=true&"
import script from "./IviewTable11.vue?vue&type=script&lang=js&"
export * from "./IviewTable11.vue?vue&type=script&lang=js&"
import style0 from "./IviewTable11.vue?vue&type=style&index=0&id=71b97350&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b97350",
  null
  
)

export default component.exports